import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['N m'] as const;

const validator = AbstractMeasurement.nomMax
    .extend({
        unit: z.literal('N m').default('N m'),
    })
    .default({});

export const TerminalTorque = {
    validator,
    units,
};

export type TerminalTorque = z.infer<typeof validator>;
